import { atom } from 'jotai';

import { Auth0ConfigResponse, Maybe, UserInitialData } from '@/types';

export const userDataAtom = atom<Maybe<UserInitialData>>(null);

export const userLoggedInViaOTPAtom = atom({
  isLoggedInViaHash: false,
  isLoading: false,
  isUsingLoginViaHash: false,
});

export const userLoggedInViaZondaAtom = atom({
  isLoggedInViaZonda: false,
  isLoading: false,
  isUsingZonda: false,
});

export const recessPosterAtom = atom<Maybe<Auth0ConfigResponse>>(null);
